import React, { useEffect, useRef } from "react";

export const AdSlot = ({ slotId, publisherId }) => {
    const pushed = useRef(false);

    useEffect(() => {
        if (!publisherId) return;
        if (!document.querySelector('script[data-sbc-adsense]')) {
            const s = document.createElement("script");
            s.async = true;
            s.crossOrigin = "anonymous";
            s.dataset.sbcAdsense = "1";
            s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${publisherId}`;
            document.head.appendChild(s);
        }
        if (!pushed.current) {
            pushed.current = true;
            try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            } catch (e) { /* ad blockers */ }
        }
    }, [publisherId]);

    if (publisherId) {
        return (
            <div data-testid={slotId} className="my-14 overflow-hidden rounded-xl border border-[#E4DFD3] bg-[#F5F2EA]">
                <ins
                    className="adsbygoogle"
                    style={{ display: "block" }}
                    data-ad-client={publisherId}
                    data-ad-format="auto"
                    data-full-width-responsive="true"
                />
            </div>
        );
    }

    return (
        <div
            data-testid={slotId}
            className="my-14 flex h-28 items-center justify-center rounded-xl border border-dashed border-[#C4BCA8] bg-[#F5F2EA]"
        >
            <span className="text-[11px] uppercase tracking-[0.3em] font-semibold text-[#6D736D]/70">Advertisement</span>
        </div>
    );
};
